import { ColDef } from 'ag-grid-community';
import { Colors } from 'routes/BudgetModule/config/constants';
import { GRADE } from 'routes/HumanResourcesModule/business/definitions';
import { floatingFilter } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';
import {
    ECHELON,
    RAW_INDEX,
    MAJORED_INDEX,
    RAW_SALARY,
    INCREASE_PERCENTAGE,
    DURATION,
    FILIERE,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/EchelonsOverview/helpers/constants';
import {
    currencyFormatter,
    percentageFormatter,
} from 'ui/AgGridReact/formatters';
import { percentageGetter } from 'ui/AgGridReact/getters';

const baseColDef = { ...floatingFilter, sortable: true, resizable: true };

export const getColDefs = (t: TranslationT): ColDef[] => [
    {
        ...baseColDef,
        flex: 1,
        field: FILIERE,
        headerName: t('humanResources.simulation.filiere'),
    },
    {
        ...baseColDef,
        flex: 1,
        field: GRADE,
        headerName: t('humanResources.simulation.grade'),
    },
    {
        ...baseColDef,
        flex: 1,
        field: ECHELON,
        headerName: t('humanResources.simulation.echelon'),
    },
    {
        ...baseColDef,
        flex: 1,
        field: RAW_INDEX,
        headerName: t('humanResources.simulation.rawIndex'),
    },
    {
        ...baseColDef,
        flex: 1,
        field: MAJORED_INDEX,
        headerName: t('humanResources.simulation.majoredIndex'),
    },
    {
        ...baseColDef,
        flex: 1,
        field: DURATION,
        headerName: t('humanResources.simulation.echelonDuration'),
        valueFormatter: (params) => `${params.value} mois`,
    },
    {
        ...baseColDef,
        field: RAW_SALARY,
        headerName: t('humanResources.simulation.rawSalary'),
        valueFormatter: currencyFormatter,
    },
    {
        ...baseColDef,
        field: INCREASE_PERCENTAGE,
        headerName: t('humanResources.simulation.increasePercentage'),
        filterValueGetter: percentageGetter,
        valueFormatter: percentageFormatter,
        cellRenderer: 'chipCellRenderer',
        cellRendererParams: {
            getColor: () => Colors.ORANGE,
            size: 'small',
        },
    },
];
